import config from "../config/app.conf.json";

export default () => ({
  url: config.api.pending_activations,
  method: "GET"
});
